import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import {AgencyMasterService} from '../../services/agency-master/agency-master.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {OrganizationService} from '../../services/organization/organization.service';
import {WorkGroupsService} from '../../services/work-groups/work-groups.service';

@Component({
    selector: 'app-work-group-admin',
    templateUrl: './work-group-admin.component.html',
    styleUrls: ['./work-group-admin.component.css'],
    standalone: false
})
export class WorkGroupAdminComponent implements OnInit {
	allAgencyList: any;
	agencyList: any;
	bureauList: any;
	selectedAgency: any;
	agencyMap: Map<string, any>;

	organizations: any;
	assignedOrganizations: any;
	availableOrganizations: any;
	originalAssignedOrganizations: any;

	workGroupsList: any;
	workGroupsMap: Map<string, any> = new Map<string, any>();
	keys: string[] = [];

	workGroupAdminForm: UntypedFormGroup;

  	constructor(private agencyMasterService: AgencyMasterService,
  		private fb: UntypedFormBuilder, private organizationService: OrganizationService,
  		private workGroupsService: WorkGroupsService, private cdref: ChangeDetectorRef) { }

  	ngAfterViewChecked() {
        this.cdref.detectChanges();
    }

	ngOnInit() {
		this.workGroupAdminForm = this.fb.group({
			agency: [null, [Validators.required]],
			bureau: [null, [Validators.required]],
			workGroup: [null],
			availableLocations: [null],
			assignedLocations: [null]
		});

		this.agencyMasterService.getAllAgency().subscribe(agencyList => {
			console.log(agencyList);
			this.agencyList = agencyList;
		}, (error) => {
			console.log("Error Retrieving Agencies!")
		}, () => {

		});

		this.workGroupAdminForm.get('agency').valueChanges.subscribe(agency => {
			console.log("Agency Changed: ", agency);
			this.bureauList = [];
			this.availableOrganizations = [];
			this.assignedOrganizations = [];
			this.workGroupsList = [];
			this.workGroupsMap = new Map<string, any>();
			this.keys = [];
			this.originalAssignedOrganizations = [];
			this.workGroupAdminForm.get('bureau').setValue(null, {onlySelf: true, emitEvent: false});
			this.workGroupAdminForm.get('workGroup').setValue(null, {onlySelf: true, emitEvent: false});
			if(this.agencyList && this.agencyList.length > 0 && agency) {
				this.agencyMasterService.getAllBureauByAgency(agency.agencyCode).subscribe(bureauList => {
					this.bureauList = bureauList;
				});
			}
		});

		this.workGroupAdminForm.get('bureau').valueChanges.subscribe(bureau => {
			console.log("Bureau Changed: ", bureau);
			this.availableOrganizations = [];
			this.assignedOrganizations = [];
			this.workGroupsList = [];
			this.workGroupsMap = new Map<string, any>();
			this.keys = [];
			this.originalAssignedOrganizations = [];
			this.workGroupAdminForm.get('workGroup').setValue(null, {onlySelf: true, emitEvent: false});
			if(bureau){
				this.workGroupsService.getWorkGroupsByAgencyMasterId(bureau.agencyMasterId).subscribe(workGroupsList => {
				console.log("Work Groups List: ", workGroupsList);
				this.workGroupsList = workGroupsList;
				this.workGroupsMap = new Map<string, any>();
				for(let workGroups of workGroupsList){
					if(this.workGroupsMap.get(workGroups.workGroup)){
						console.log("Existing Key Found, Pushing!")
						this.workGroupsMap.get(workGroups.workGroup).push(workGroups);
					} else {
						console.log("New Key Found, Setting!")
						let key: string = workGroups.workGroup;
						let value: any[] = [workGroups];
						this.workGroupsMap.set(key, value);
					}
				}
				this.keys = Array.from(this.workGroupsMap.keys());
				console.log("Work Groups Map: ", this.workGroupsMap);
				}, (error) => {

				}, () => {
					this.organizationService.getOrganizationsByAgencyMasterId(bureau.agencyMasterId).subscribe(organizations => {
						this.organizations = organizations;
						this.availableOrganizations = organizations;
						console.log("Organizations: ", organizations);
					});
				});
			}
		});

		this.workGroupAdminForm.get('workGroup').valueChanges.subscribe(value => {
			console.log("All Orgs: ", this.organizations);
			this.assignedOrganizations = [];
			this.availableOrganizations = [];
			this.originalAssignedOrganizations = [];
			for(let org of this.organizations){
				this.availableOrganizations.push(org);
			}
			if(value){
				console.log("Work Group Key: ", value);
				let workGroups = this.workGroupsMap.get(value);
				console.log("Work Group Value: ", workGroups);
				for(let workGroup of workGroups){
					for(let organization of this.availableOrganizations){
						if(organization.organizationId == workGroup.organizationId){
							this.assignedOrganizations.push(organization);
							this.originalAssignedOrganizations.push(organization);
							this.availableOrganizations.splice(this.availableOrganizations.indexOf(organization), 1);
							break;
						}
					}
				}
			}
		});

		this.workGroupAdminForm.get('availableLocations').valueChanges.subscribe(value => {
			console.log("Available Locations: ", value);
		});

		this.workGroupAdminForm.get('assignedLocations').valueChanges.subscribe(value => {
			console.log("Assigned Locations: ", value);
		});
  	}

  	assignLocations(){
  		let locations: [] = this.workGroupAdminForm.get('availableLocations').value;
  		let indicies: []
  		if(locations && locations.length > 0){
  			for(let location of locations){
  				this.assignedOrganizations.push(location);
  				this.availableOrganizations.splice(this.availableOrganizations.indexOf(location), 1);
  			}
  		}
  		console.log("Available Orgs: ", this.availableOrganizations);
  		console.log("Assigned Orgs: ", this.assignedOrganizations);
  	}

  	unassignLocations(){
  		let locations: [] = this.workGroupAdminForm.get('assignedLocations').value;
  		if(locations && locations.length > 0){
  			for(let location of locations){
  				this.availableOrganizations.push(location);
  				this.assignedOrganizations.splice(this.assignedOrganizations.indexOf(location), 1);
  			}
  		}
  		console.log("Available Orgs: ", this.availableOrganizations);
  		console.log("Assigned Orgs: ", this.assignedOrganizations);
  	}

  	update(){

  		console.log("In update!", this.workGroupAdminForm.get('workGroup').value);
  		console.log("Assigned Locations: ", this.assignedOrganizations);
  		console.log("Original Locations: ", this.originalAssignedOrganizations);
  		let hasSameOrgs = true;
  		if(this.workGroupAdminForm.get('workGroup').value != null){
  			if(this.assignedOrganizations && this.originalAssignedOrganizations && this.assignedOrganizations.length == this.originalAssignedOrganizations.length){
	  			for(let org of this.assignedOrganizations){
	  				if(!this.originalAssignedOrganizations.includes(org)){
	  					hasSameOrgs = false;
	  					break;
	  				}
	  			}
	  		} else {
	  			hasSameOrgs = false;
	  		}
	  		if(hasSameOrgs){
	  			console.log("No changes made!")
	  		} else {
	  			console.log("Changes made!")
	  			this.workGroupsService.updateWorkGroups(this.workGroupAdminForm.get('workGroup').value, this.assignedOrganizations, this.originalAssignedOrganizations).subscribe(value => {
	  				console.log(value);
	  			}, (error) => {

	  			}, () => {
	  				this.workGroupAdminForm.get('agency').setValue(null);
	  			});
	  		}
  		} else {
  			if(this.workGroupsMap.keys() && Array.from(this.workGroupsMap.keys()).length > 0){
  				console.log("Here 1!");
  				let largestKey = 0;
  				let keysStringArray = Array.from(this.workGroupsMap.keys());
  				let keys = keysStringArray.map(x => parseInt(x));
  				for(let key of keys){
  					if(key > largestKey){
  						largestKey = key;
  					}
  				}
  				let newKey = (largestKey + 1) + '';
  				this.workGroupsService.updateWorkGroups(newKey, this.assignedOrganizations, this.originalAssignedOrganizations).subscribe(value => {
	  				console.log(value);
	  			}, (error) => {

	  			}, () => {
	  				this.workGroupAdminForm.get('agency').setValue(null);
	  			});

  			} else {
  				console.log("Here 2!");
  				this.workGroupsService.updateWorkGroups("1", this.assignedOrganizations, this.originalAssignedOrganizations).subscribe(value => {
	  				console.log(value);
	  			}, (error) => {

	  			}, () => {
	  				this.workGroupAdminForm.get('agency').setValue(null);
	  			});
  			}
  		}
  	}

}
